module.exports = __webpack_public_path__ + "static/bbqs-direct-b9ac6f3c88b9926fbc373e51c4e518b1.png";